var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "registerScreen" },
        [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row --mainRow" }, [
              _c("div", {
                staticClass:
                  "col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "paddingBox" }, [
                    _c("h2", [_vm._v("Zadanie EAN kódov")]),
                    _vm._v(" "),
                    _vm.responseText != ""
                      ? _c(
                          "div",
                          {
                            class: "alert alert-" + _vm.responseType,
                            attrs: { role: "alert" }
                          },
                          [
                            _c("span", { class: "icon --" + _vm.responseType }),
                            _vm._v(
                              _vm._s(_vm.responseText) +
                                "\n                        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-7 col-xl-7" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "o-widget --lightBg --small --rounded d-flex mb-4 justify-content-between"
                          },
                          [
                            _c("div", { staticClass: "m-widget__text" }, [
                              _vm._v("Potrebných k adopcii")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "m-widget__codes",
                                attrs: { id: "codes_remaining" }
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.remaining_codes) +
                                    " \n\n                                        "
                                ),
                                _vm._v(" "),
                                _vm.remaining_codes == 1
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                            kód\n                                        "
                                      )
                                    ])
                                  : _vm.remaining_codes > 1 &&
                                    _vm.remaining_codes < 5
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                            kódy\n                                        "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                                            kódov\n                                        "
                                      )
                                    ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("form", { on: { submit: _vm.formSubmit } }, [
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "col-12 col-md-12" }, [
                              _c(
                                "label",
                                { attrs: { for: "ean-kod" } },
                                [
                                  _vm._v(
                                    "\n                                                EAN kód \n                                                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "float-right mr-4",
                                      attrs: { id: "popoverEan" }
                                    },
                                    [_vm._v("Kde nájdem EAN kód?")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: "popoverEan",
                                        triggers: "click",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v("Kde ho nájdem?")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "Kódy EAN sa používajú na označovanie tovaru."
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              " Nájsť ich môžeš na obaloch produktov."
                                            )
                                          ]),
                                          _c("p", [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  "https://www.adoptujkravicku.sk/hra/dist/images/content/ean-kod.jpg"
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.ean_code,
                                    expression: "ean_code"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: { value: _vm.ean_code },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.ean_code = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._m(1)
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-12" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn --primary w-100 mb-2",
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      id: "codes_remaining_button"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                Pridať ean kód 1/1"
                                    ),
                                    _c("span", {
                                      staticClass: "icon --barcodeIcon"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn --secondary w-100",
                                    attrs: {
                                      to: { name: "kravicky" },
                                      id: "codes_remaining_button"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                Prejsť do hry\n                                            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-5 col-xl-5" }, [
                        _c("aside", { staticClass: "o-widget mb-md-5" }, [
                          _c(
                            "div",
                            { staticClass: "m-widgetContent" },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("strong", [_vm._v("Tvoje už vložené kódy:")]),
                              _vm._v(" "),
                              _vm._l(_vm.ean_codes, function(item, index) {
                                return _c("span", [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(item.ean_code)
                                  ),
                                  _c("br")
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          !_vm.isDisabled
                            ? _c("div", { staticClass: "separator" })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isDisabled
                            ? _c("div", { staticClass: "m-widgetContent" }, [
                                _vm._v(
                                  "\n                                        Kravička je rezervovaná ešte"
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("strong", { staticClass: "--colorOrange" }, [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.remaining_days) +
                                      " \n\n                                            "
                                  ),
                                  _vm._v(" "),
                                  _vm.remaining_days == 1
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                                deň\n                                            "
                                        )
                                      ])
                                    : _vm.remaining_days > 1 &&
                                      _vm.remaining_days < 5
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                                dni\n                                            "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                                                dní\n                                            "
                                        )
                                      ])
                                ])
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "modalUspesnaAdopcia",
              staticClass: "modal fade",
              attrs: {
                id: "modalUspesnaAdopcia",
                "hide-footer": "",
                "hide-header": "",
                centered: "",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "modalLostPasswordTitle",
                "aria-hidden": "true"
              }
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "m-modalInfo__close",
                  attrs: { block: "" },
                  on: {
                    click: function($event) {
                      return _vm.$bvModal.hide("modalUspesnaAdopcia")
                    }
                  }
                },
                [_c("span", { staticClass: "icon" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body o-modalInfo" }, [
                _c(
                  "div",
                  { staticClass: "m-modalLostPassword__content text-center" },
                  [
                    _c("img", {
                      staticClass: "img-fluid mb-3",
                      attrs: { src: "assets/img/checkCircle.png", alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "h2",
                      { staticClass: "m-modalLostPassword__name text-center" },
                      [_vm._v("Výborne! Adoptoval si si novú kravičku")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-center" }, [
                      _vm._v(
                        "Splnil si potrebný limit EAN kódov na adopciu tvojej kravičky. Na tvoj e-mail sme ti poslali jej rodný list. Zadané EAN kódy boli premenené na dukáty, ktoré využiješ v hre. Prajeme veľa zábavy."
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-center mb-2" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn --primary",
                            attrs: { to: { name: "kravicky" } }
                          },
                          [_vm._v("Prejsť do hry")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn --secondary",
                          attrs: {
                            href:
                              "https://adoptujkravicku.sk/hra/kravicka/rodny-list/" +
                              _vm.kravicka_id
                          }
                        },
                        [_vm._v("Rodný list kravičky")]
                      )
                    ])
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "m-stepNavigation" }, [
      _c("li", { staticClass: "a-stepNavigation__item is-done mb-2 mb-md-0" }, [
        _vm._v("VÝBER KRAVIČKY")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-stepNavigation__item is-done mb-2 mb-md-0" }, [
        _vm._v("ÚDAJE KRAVIČKY")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "a-stepNavigation__item is-active" }, [
        _vm._v("EAN KÓDY")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "float-right mr-2 mt-1 extenralLink",
        attrs: {
          href:
            "https://www.adoptujkravicku.sk/mobilna-aplikacia-adoptuj-kravicku-skener/"
        }
      },
      [
        _vm._v(
          "\n                                                Skenujte kódy pomocou aplikácie"
        ),
        _c("span", { staticClass: "icon" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widgetContent__description" }, [
      _c("p", [
        _vm._v(
          "EAN kódy získavate zakúpením produktov Slovenskej Mliečnej Rodiny. Kravička vám bude automaticky rezervovaná po dobu 10 dní. K zadávaniu EAN kódov s môžete kedykoľvek vrátiť."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }